import { render, staticRenderFns } from "./ClassroomGridItem.vue?vue&type=template&id=417bef6e&scoped=true"
import script from "./ClassroomGridItem.vue?vue&type=script&lang=js"
export * from "./ClassroomGridItem.vue?vue&type=script&lang=js"
import style0 from "./ClassroomGridItem.vue?vue&type=style&index=0&id=417bef6e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417bef6e",
  null
  
)

export default component.exports